export const SUPPORT_EXPORT_NO_DATA_MESSAGE = 'No data available! Try with different filters.';

export const getSupportExportErrorMessage = (error, fallbackMessage) => {
  const status = error?.status ?? error?.response?.status;

  return status === 204 ? SUPPORT_EXPORT_NO_DATA_MESSAGE : fallbackMessage;
};
